<div class="min-h-screen w-full bg-neutral-100">
  <app-header></app-header>

  <main class="w-full py-6">
    <div class="max-w-[1440px] mx-auto px-4
                grid grid-cols-1 lg:grid-cols-[220px_minmax(0,1fr)] gap-6">
      <app-profile-sidebar></app-profile-sidebar>

      <div class="space-y-6">
        <!-- Sem :id na rota /events -->
        <section *ngIf="state === 'no-id'" class="bg-white shadow rounded-xl p-6 md:p-8 text-center">
          <h1 class="text-xl font-semibold text-gray-900 mb-2">Nenhum evento selecionado</h1>
          <p class="text-gray-600 mb-6">Escolha um evento no painel para ver os detalhes.</p>
          <a routerLink="/control"
             class="inline-flex items-center justify-center rounded-full bg-[#E90128] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#c70020]">
            Ir para o painel
          </a>
        </section>

        <!-- Carregando -->
        <div *ngIf="state === 'loading'" class="bg-white shadow rounded-xl p-8 flex flex-col items-center gap-4">
          <div class="h-10 w-10 border-2 border-gray-200 border-t-[#E90128] rounded-full animate-spin" aria-hidden="true"></div>
          <p class="text-gray-600 text-sm">Carregando evento…</p>
        </div>

        <!-- Erro -->
        <section *ngIf="state === 'error'" class="bg-white shadow rounded-xl p-6 md:p-8 text-center">
          <h1 class="text-xl font-semibold text-gray-900 mb-2">Não foi possível exibir o evento</h1>
          <p class="text-gray-600 mb-2">{{ errorMessage }}</p>
          <a routerLink="/control"
             class="inline-flex mt-4 text-sm font-medium text-[#E90128] hover:underline">
            Voltar ao painel
          </a>
        </section>

        <!-- Conteúdo -->
        <ng-container *ngIf="state === 'ready' && event as ev">
          <app-event-hero [event]="ev"></app-event-hero>
          <app-ticket-lots [lots]="ev.lots" (select)="onSelectLot($event)"></app-ticket-lots>

          <section class="bg-white shadow p-4 md:p-6 !mt-0">
            <h2 class="font-semibold uppercase text-3xl text-gray-900 mb-3">
              {{ ev.descriptionTitle?.trim() || 'Sobre o evento' }}
            </h2>
            <p class="border-4 w-full border-black mb-4"></p>
            <div class="text-gray-700 leading-relaxed" [innerHTML]="ev.description"></div>
          </section>

          <section *ngIf="galleryImages.length" class="bg-white shadow p-4 md:p-6">
            <h2 class="font-semibold uppercase text-3xl text-gray-900 mb-3">Galeria</h2>
            <p class="border-4 w-full border-black mb-4"></p>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <button
                type="button"
                *ngFor="let img of galleryImages"
                (click)="openGalleryLightbox(img)"
                class="group block w-full text-left rounded-lg overflow-hidden border-0 p-0 bg-transparent cursor-pointer
                       focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128] focus-visible:ring-offset-2"
              >
                <span class="block">
                  <img
                    [src]="img.image_url"
                    [alt]="img.description || 'Imagem do evento'"
                    class="w-full h-48 object-cover rounded-lg bg-gray-100 transition-transform duration-200 group-hover:scale-[1.02] group-hover:shadow-md"
                    loading="lazy"
                  />
                  <span *ngIf="img.description" class="block text-sm text-gray-600 mt-2 px-0.5 line-clamp-2">{{ img.description }}</span>
                </span>
              </button>
            </div>
          </section>

          <app-event-agenda *ngIf="ev.agenda.length" [items]="ev.agenda"></app-event-agenda>

          <app-event-attendees *ngIf="ev.attendees.length" [attendees]="ev.attendees"></app-event-attendees>

          <section *ngIf="!ev.attendees.length && (detailContent?.total_registrations ?? 0) > 0"
                   class="bg-white rounded-b-xl shadow p-4 md:p-6">
            <h2 class="font-semibold uppercase text-3xl text-gray-900 mb-3">Inscrições</h2>
            <p class="border-4 w-full border-black mb-4"></p>
            <p class="text-gray-700">
              Este evento conta com
              <strong>{{ detailContent?.total_registrations }}</strong>
              {{ (detailContent?.total_registrations ?? 0) === 1 ? 'inscrição' : 'inscrições' }}.
            </p>
          </section>

          <section class="bg-white shadow p-4 md:p-6 rounded-b-xl">
            <h2 class="font-semibold uppercase text-3xl text-gray-900 mb-3">Depoimentos</h2>
            <p class="border-4 w-full border-black mb-4"></p>

            <div class="mb-10 pb-10 border-b border-gray-100">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Sua avaliação</h3>

              <div *ngIf="myTestimonial && !testimonialEditing" class="space-y-4">
                <ng-container *ngIf="myTestimonial as mine">
                  <p *ngIf="!mine.is_approved"
                     class="inline-flex rounded-full bg-amber-50 px-3 py-1 text-sm font-medium text-amber-800 border border-amber-200">
                    Aguardando moderação — seu depoimento será publicado após aprovação.
                  </p>
                  <div class="flex gap-1 mb-1"
                       [attr.aria-label]="'Nota ' + mine.rating + ' de 5'">
                    <span *ngFor="let on of testimonialStarsExact(mine.rating)"
                          class="text-lg leading-none"
                          [class.text-amber-400]="on"
                          [class.text-gray-300]="!on">{{ on ? '★' : '☆' }}</span>
                  </div>
                  <blockquote class="text-gray-800 leading-relaxed border-l-4 border-gray-200 pl-4">
                    {{ mine.testimonial }}
                  </blockquote>
                  <div class="flex flex-wrap gap-3 pt-2">
                    <button
                      type="button"
                      (click)="startTestimonialEdit()"
                      [disabled]="testimonialSaving"
                      class="inline-flex items-center justify-center rounded-full border border-gray-300 bg-white px-5 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 disabled:opacity-50">
                      Editar
                    </button>
                    <button
                      type="button"
                      (click)="deleteMyTestimonial()"
                      [disabled]="testimonialSaving"
                      class="inline-flex items-center justify-center rounded-full border border-red-200 bg-white px-5 py-2 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:opacity-50">
                      Excluir
                    </button>
                  </div>
                </ng-container>
              </div>

              <div *ngIf="!myTestimonial || testimonialEditing" class="space-y-4 mt-4">
                <div>
                  <span class="block text-sm font-medium text-gray-700 mb-2">Nota de 0 a 5</span>
                  <div class="flex flex-wrap items-center gap-1"
                       role="group"
                       [attr.aria-label]="'Selecionar nota, atual ' + testimonialDraftRating + ' de 5'">
                    <button
                      *ngFor="let n of testimonialStarKeys"
                      type="button"
                      (click)="setTestimonialDraftRating(n)"
                      [disabled]="testimonialSaving"
                      [class.text-amber-400]="testimonialDraftRating >= n"
                      [class.text-gray-300]="testimonialDraftRating < n"
                      class="text-2xl leading-none p-1 rounded transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128] focus-visible:ring-offset-2 disabled:opacity-50"
                      [attr.aria-pressed]="testimonialDraftRating >= n">
                      ★
                    </button>
                    <button
                      type="button"
                      (click)="setTestimonialDraftRating(0)"
                      [disabled]="testimonialSaving"
                      class="ml-2 text-sm text-gray-600 underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128] rounded disabled:opacity-50">
                      Sem nota (0)
                    </button>
                  </div>
                </div>
                <div>
                  <label for="event-testimonial-text" class="block text-sm font-medium text-gray-700 mb-2">Comentário</label>
                  <textarea
                    id="event-testimonial-text"
                    name="eventTestimonialText"
                    [(ngModel)]="testimonialDraftText"
                    [disabled]="testimonialSaving"
                    rows="4"
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder:text-gray-400 focus:border-[#E90128] focus:outline-none focus:ring-1 focus:ring-[#E90128] disabled:bg-gray-50 disabled:text-gray-500"
                    placeholder="Conte como foi sua experiência neste evento…"
                  ></textarea>
                </div>
                <div class="flex flex-wrap gap-3">
                  <button
                    type="button"
                    (click)="submitTestimonial()"
                    [disabled]="testimonialSaving"
                    class="inline-flex items-center justify-center rounded-full bg-[#E90128] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#c70020] disabled:opacity-50">
                    <ng-container *ngIf="!testimonialSaving">
                      {{ testimonialEditing ? 'Salvar alterações' : 'Enviar depoimento' }}
                    </ng-container>
                    <span *ngIf="testimonialSaving">Enviando…</span>
                  </button>
                  <button
                    *ngIf="myTestimonial && testimonialEditing"
                    type="button"
                    (click)="cancelTestimonialEdit()"
                    [disabled]="testimonialSaving"
                    class="inline-flex items-center justify-center rounded-full border border-gray-300 bg-white px-6 py-2.5 text-sm font-semibold text-gray-800 hover:bg-gray-50 disabled:opacity-50">
                    Cancelar
                  </button>
                </div>
              </div>

              <p *ngIf="testimonialBannerError" class="text-sm text-red-600 mt-4" role="alert">
                {{ testimonialBannerError }}
              </p>
            </div>

            <div *ngIf="approvedTestimonialsForList.length">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">O que os membros disseram</h3>
              <ul class="space-y-6 divide-y divide-gray-100">
                <li *ngFor="let t of approvedTestimonialsForList" class="pt-6 first:pt-0">
                  <div *ngIf="t.member?.public_id?.trim() && t.member?.name?.trim()"
                       class="flex items-center gap-3 mb-3 min-w-0">
                    <a
                      [routerLink]="['/members', t.member!.public_id.trim()]"
                      class="shrink-0 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128]"
                      [attr.aria-label]="'Ver perfil de ' + t.member!.name"
                    >
                      <img
                        [src]="testimonialAvatar(t)"
                        [alt]="t.member!.name"
                        class="w-12 h-12 rounded-full object-cover bg-gray-100"
                      />
                    </a>
                    <div class="min-w-0 flex-1">
                      <a
                        [routerLink]="['/members', t.member!.public_id.trim()]"
                        class="font-semibold text-gray-900 hover:text-[#E90128] block truncate focus:outline-none focus-visible:underline"
                      >
                        {{ t.member!.name }}
                      </a>
                      <span class="text-xs text-gray-500 truncate block">{{
                        formatTestimonialCommentAt(t.created_at)
                      }}</span>
                    </div>
                  </div>
                  <div class="flex gap-1 mb-2" aria-hidden="true">
                    <span *ngFor="let on of testimonialStars(t.rating)"
                          class="text-amber-400 text-lg">{{ on ? '★' : '☆' }}</span>
                  </div>
                  <blockquote class="text-gray-700 leading-relaxed">{{ t.testimonial }}</blockquote>
                </li>
              </ul>
            </div>
          </section>
        </ng-container>
      </div>
    </div>
  </main>

  <footer class="border-t">
    <app-footer></app-footer>
  </footer>

  <!-- Lightbox da galeria -->
  <div
    *ngIf="galleryLightbox as g"
    class="fixed inset-0 z-[200] flex items-center justify-center p-4 sm:p-8"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'Imagem ampliada: ' + (g.description || 'evento')"
    (click)="closeGalleryLightbox()"
  >
    <div class="absolute inset-0 bg-black/85 backdrop-blur-[1px]" aria-hidden="true"></div>
    
    <button
      type="button"
      (click)="closeGalleryLightbox()"
      class="fixed top-4 right-4 z-30 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-2xl leading-none text-white hover:bg-white/40 shadow-lg focus:outline-none"
      aria-label="Fechar"
    >
      ×
    </button>

    <div
      class="relative z-10 max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-lg shadow-2xl flex flex-col items-center"
      (click)="$event.stopPropagation()"
    >
      <img
        [src]="g.image_url"
        [alt]="g.description || 'Imagem do evento'"
        class="w-full h-auto block rounded-t-lg bg-gray-900"
      />
      <p *ngIf="g.description" class="p-4 w-full bg-black/95 text-center text-sm text-white/95 rounded-b-lg border-t border-white/10">{{ g.description }}</p>
    </div>
  </div>

  <!-- Popup de compra (loading/erro) -->
  <div
    *ngIf="paymentModalState !== 'hidden'"
    class="fixed inset-0 z-[210] flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    aria-label="Status da compra do ingresso"
  >
    <div class="absolute inset-0 bg-black/70" aria-hidden="true"></div>
    <div class="relative z-10 w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
      <div *ngIf="paymentModalState === 'loading'" class="flex flex-col items-center gap-4 text-center">
        <div class="h-10 w-10 border-2 border-gray-200 border-t-[#E90128] rounded-full animate-spin" aria-hidden="true"></div>
        <h3 class="text-lg font-semibold text-gray-900">Aguarde um instante</h3>
        <p class="text-sm text-gray-600">{{ paymentModalMessage }}</p>
      </div>

      <div *ngIf="paymentModalState === 'error'" class="space-y-4 text-center">
        <h3 class="text-lg font-semibold text-gray-900">Não foi possível concluir</h3>
        <p class="text-sm text-gray-600">{{ paymentModalMessage }}</p>
        <button
          type="button"
          (click)="closePaymentModal()"
          class="inline-flex items-center justify-center rounded-full bg-[#E90128] px-5 py-2 text-sm font-semibold text-white hover:bg-[#c70020]"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
